<template>
  <div>
  <v-card>
    <v-card-title>
      <h2 class="mb-4 text-primary">Configurer l'e-mail</h2>
    </v-card-title>

    <v-card-text>
      <h3><span class="required">Émetteur</span></h3>
      <v-select :items="accountSenders" outlined style="padding-top: 0 !important;"
                class="no-details mb-6 w-auto h-auto"
                item-text="emailable.email" return-object :value="emailSender" v-model="emailSender">
        <v-tooltip slot="append-outer" bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">help</v-icon>
          </template>
          <span>Adresse E-mail et Nom d'expéditeur que verront vos prestataires.</span>
        </v-tooltip>

        <template v-slot:selection="selection">
                            <span v-if="selection.item.name !== null" class="pr-2">
                                {{ selection.item.name }}
                            </span>
          <span>({{ selection.item.emailable.email }})</span>
        </template>
        <template v-slot:item="item">
                            <span v-if="item.item.name !== null" class="pr-2">
                                {{ item.item.name }}
                            </span>
          <span>({{ item.item.emailable.email }})</span>
        </template>
      </v-select>

      <h3><span class="required">Objet</span></h3>
      <v-text-field background-color="white" outlined style="padding-top: 0 !important;"
                    :value="emailSubject"
                    v-model="emailSubject" class="subject-input">
      </v-text-field>

      <h3><span class="required">Contenu de l'e-mail</span></h3>
      <ckeditor :editor="editor"
                :value="emailContent"
                v-html="emailContent"
                @input="updateEmailContent">
      </ckeditor>

        <div v-if="account.configurations.payfipLink !== null && !acquitted">
            <v-checkbox v-model="withPaymentLink" label="Ajouter un lien de paiement au mail" hide-details
                        style="padding-top: 0 !important;" class="mr-3 mt-0 pt-0">
            </v-checkbox>
            <div class="text-center valid-button" v-if="withPaymentLink">
                <div class="send-button">Procédez au paiement</div>

                <p>Ou copiez/collez dans votre navigateur le lien suivant :<br>
                    https://destination.uska/redirect-payment/*******</p>
            </div>
        </div>

      <div :class="{ 'disabled-box': emailSender === null }">
        <h3 class="mt-6" style="margin-bottom: 0 !important;">Signature</h3>
        <div class="d-flex align-items-center">
          <div class="mt-auto mb-auto">
            <v-checkbox v-model="generateSignature" label="Générer automatiquement la signature" hide-details
                        style="padding-top: 0 !important;" class="mr-3 mt-0 pt-0">
            </v-checkbox>
          </div>

          <div class="mt-auto mb-auto">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">help</v-icon>
              </template>
              <span>
                            En cochant cette case, la signature de l'émetteur sera utilisée
                        </span>
            </v-tooltip>
          </div>
        </div>

        <div class="mt-3 valid-button mb-0" v-if="generateSignature">
          <div class="mt-3">
            <v-progress-circular indeterminate color="primary" v-if="loadSignature"></v-progress-circular>
            <div v-else v-html="signature"></div>
          </div>
        </div>

        <div v-else class="mt-3">
          <ckeditor :editor="editor" v-model="signature" @input="updateSignature"></ckeditor>
        </div>
      </div>

      <v-btn text small @click="openInvoicePdf" style="text-transform: unset" class="mt-6 pl-0">
        <v-icon>attach_file</v-icon>Voir la facture qui sera en pièce-jointe
      </v-btn>
    </v-card-text>

    <v-card-actions class="w-100 px-6 d-flex justify-content-between">
      <v-btn color="error" @click="closeModal">
        Annuler
      </v-btn>

      <v-btn color="primary" @click="sendInvoice"
             :disabled="emailSender === null || emailContent === '' || emailSubject === ''">
        Envoyer
      </v-btn>
    </v-card-actions>
  </v-card>
  </div>
</template>

<script>

import { mapState } from "vuex"
import ClassicEditor from '../../../plugins/ckeditor'

export default {
  name: 'InvoiceMailModal',
  props: [ 'answerId', 'campaign', 'acquitted', 'waitingPayment'],
  data() {
    return {
        emailContent: "",
        emailSubject: "Facture de votre partenariat",
        emailSender: {},
        editor: ClassicEditor,
        generateSignature: false,
        loadSignature: false,
        signature: '',
        accountSenders: [],
        withPaymentLink: false,
    }
  },
    methods: {
        sendInvoice() {
            this.$global.loading = true

            let payload = {
                'answerId': this.answerId,
                'sender': this.emailSender,
                'subject': this.emailSubject,
                'emailContent': this.emailContent,
                'signature': this.signature,
                'withPaymentLink': this.withPaymentLink,
            }

            this.$http.post("auth/invoice/cadh-answer-invoice/send-invoice", payload).then(
              this.$global.loading = false,
            )
            this.closeModal()
        },
        prepareEmailModal() {
            this.accountSenders = this.account.senders.filter(sender => sender.state_label === 'Validée')
            this.emailSender = this.accountSenders.find(sender => sender.id === this.campaign.sender_id)

            if(this.acquitted) {
                this.emailSubject = "Facture acquittée de votre partenariat"
            }

            this.emailContent = "<p>Cher(e) partenaire,</p>" +
              "<p>Veuillez trouver ci-joint la facture suite à votre partenariat. </p>" +
              "<p>Bien Cordialement.</p>"

            if(this.waitingPayment && !this.acquitted) {
                this.withPaymentLink = true
            }
        },
        getSignature() {
            if (this.emailSender !== null) {
                this.loadSignature = true

                this.$http.get('auth/user/signature/' + this.emailSender.id).then(res => {
                    this.signature = res.body.data.signature

                    this.loadSignature = false
                })
            }
        },
        updateSignature(text) {
            this.signature = text
        },
        updateEmailContent(text) {
            this.emailContent = text
        },
        openInvoicePdf() {
            this.$global.$emit('open-invoice-pdf')
        },
        closeModal() {
            this.$global.$emit('close-invoice-email-modal')
        }
    },
    computed: {
        ...mapState("account", ["account"]),
    },
    watch: {
        generateSignature() {
            if (this.generateSignature) {
                this.getSignature()
            }
        },
        acquitted() {
            if(this.acquitted) {
                this.emailSubject = "Facture acquittée de votre partenariat"
            } else {
                this.emailSubject = "Facture de votre partenariat"
            }

            this.withPaymentLink = !!(this.waitingPayment && !this.acquitted);
        },
        waitingPayment() {
            this.withPaymentLink = !!(this.waitingPayment && !this.acquitted);
        }
    },
    created() {
        this.prepareEmailModal()
    }
}
</script>